import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TabsModule } from 'primeng/tabs';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { CommonConfigService } from '../../../../utils/common-config';
import { IMaskModule } from 'angular-imask';
import { Router } from '@angular/router';

@Component({
    selector: 'cwe-rate',
    standalone: true,
    imports: [ButtonModule, TabsModule, DialogModule, InputTextModule, FormsModule, TableModule, IMaskModule],
    templateUrl: './cwe-rate.component.html',
    styleUrl: './cwe-rate.component.less',
})
export class CweRateComponent implements OnInit {
    constructor(
        private http: HttpClient,
        private commonConfigService: CommonConfigService,
        private router: Router
    ) {}
    cweRate!: string;
    percentMask = {};

    ngOnInit() {
        this.percentMask = this.commonConfigService.getPercentWithDecimalConfig();
        this.getCwt();
    }

    getCwt() {
        this.http
            .get(`${environment.apiUrl}/Configure/CWERate`, {
                withCredentials: true,
                observe: 'response',
            })
            .subscribe({
                next: (res: HttpResponse<any>) => {
                    this.cweRate = (res.body * 100).toFixed(2).toString() + '%';
                },
                error: (err) => {
                    if (err.status === 401) {
                        this.router.navigate(['/configuration/sign-in']);
                    }
                },
            });
    }

    saveChanges() {
        let rate = (parseFloat(this.cweRate.replace('%', '')) / 100).toFixed(4);
        let params = {
            rate: parseFloat(rate),
        };
        this.http
            .post(`${environment.apiUrl}/Configure/CWERate?rate=${params.rate}`, {
                withCredentials: true,
            })
            .subscribe({
                next: (res) => {
                    this.getCwt();
                },
                error: (err) => {
                    if (err.status === 401) {
                        this.router.navigate(['/configuration/sign-in']);
                    }
                },
            });
    }

    discardChanges() {
        this.http
            .post(`${environment.apiUrl}/Configure/CWERate?rate=0`, {
                withCredentials: true,
            })
            .subscribe({
                next: (res) => {
                    this.getCwt();
                },
                error: (err) => {
                    if (err.status === 401) {
                        this.router.navigate(['/configuration/sign-in']);
                    }
                },
            });
    }
}
